(function() {
  var bar = document.getElementById('sticky-atc-bar');
  if (!bar) return;

  var trigger = document.querySelector('.my_multicolumn');
  if (!trigger) {
    trigger = document.querySelector('product-info .product-form__submit')
      || document.querySelector('.product-form__submit');
  }
  if (!trigger) return;

  var ticking = false;
  function check() {
    var rect = trigger.getBoundingClientRect();
    if (rect.bottom <= 0) {
      bar.style.transform = 'translateY(0)';
    } else {
      bar.style.transform = 'translateY(-100%)';
    }
    ticking = false;
  }

  window.addEventListener('scroll', function() {
    if (!ticking) { requestAnimationFrame(check); ticking = true; }
  }, { passive: true });

  check();
})();
